import { ReactNode } from "react"
import { Card, CardContent, CardFooter } from "./ui/card"
import { Button } from "../components/ui/button"
import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"


export function ServiceCard({ icon, title, description, href }) {
  return (
    <Card className="transition-all hover:shadow-md border-t-4 border-t-transparent hover:border-t-primary hover:translate-y-[-5px] duration-300 group">
      <CardContent className="p-6">
        <div className="p-3 mb-4 rounded-full bg-gray-100 inline-flex group-hover:bg-gray-200 transition-colors">
          {icon}
        </div>
        <h3 className="mb-2 text-xl font-bold">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
      </CardContent>
      <CardFooter className="pt-0 pb-6 px-6">
        <Button variant="link" className="p-0 h-auto text-primary group-hover:underline" asChild>
          <Link to={href} className="flex items-center">
            Learn More <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  )
}
